import { useEffect } from 'react'
import { useOutlet, useLocation } from 'react-router-dom'
import Header from '../Header'
import Footer from '../Footer'
import { useRouteTracking } from '../../lib/track'
import styles from './Layout.module.css'

export default function Layout() {
  const outlet = useOutlet()
  const location = useLocation()

  useRouteTracking()

  useEffect(() => {
    // Reset scroll position on route change (and disable browser's scroll restoration).
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior })
  }, [location.pathname])

  return (
    <div className={styles.layout}>
      <a href="#main-content" className={styles.skipLink}>
        Skip to main content
      </a>
      <Header />
      <main id="main-content" key={location.pathname} className={`${styles.content} page-transition`}>
        {outlet}
      </main>
      <Footer />
    </div>
  )
}
